import { queryOptions } from '@tanstack/react-query';

import {
    NOTES_SETTINGS_TYPE,
    TELEHEALTH_SETTINGS_TYPE,
} from '../model/practice-member-settings.schemas';
import type { PracticeMemberSettingsType } from '../model/practice-member-settings.types';
import { practiceMemberSettingsApi } from './practice-member-settings.api';

export const queryKeys = {
    all: ['practice-member-settings'] as const,
    byType: (type: PracticeMemberSettingsType) => [...queryKeys.all, type] as const,
};

export function practiceMemberSettingsByTypeOptions<T extends PracticeMemberSettingsType>(type: T) {
    return queryOptions({
        queryKey: queryKeys.byType(type),
        queryFn: ({ signal }) => practiceMemberSettingsApi.getByType(type, signal),
        // The mutation writes this entry on success, so a background refetch would add nothing.
        staleTime: Infinity,
    });
}

export function notesSettingsOptions() {
    return practiceMemberSettingsByTypeOptions(NOTES_SETTINGS_TYPE);
}

export function telehealthSettingsOptions() {
    return practiceMemberSettingsByTypeOptions(TELEHEALTH_SETTINGS_TYPE);
}
